module.exports = __webpack_public_path__ + "fef48b54f25a165418e0d25ab2c49446.webp";